import {
    FieldContent, ErrorId, ExtendedErrorId, overrideValidator, Validator,
} from '@sheerid/jslib';


export const useCustomDischargeDateValidator = () => {
    const currentDate = new Date();
    const thisYear = currentDate.getFullYear();
    const lastYear = thisYear - 1;
    const thisMonth = currentDate.getMonth() - 1;// for some reason get month is off by 1 month
    const DECIMAL_RADIX = 10;

    const isValidDateFormat = (value: string): boolean => {
        // eslint-disable-next-line no-useless-escape
        const VALID_DATE_FORMAT_REGEXP = /^\d{4}[\-\s\/]\d{1,2}[\-\s\/]\d{1,2}$/;

        if (VALID_DATE_FORMAT_REGEXP.test(value)) {
            return true;
        }
        return false;
    };

    const isValidDate = (value: string): boolean => {
        const dateParts = value.split('-');
        const dateYear = parseInt(dateParts[0], DECIMAL_RADIX);
        const dateMonth = parseInt(dateParts[1], DECIMAL_RADIX);
        const dateDay = parseInt(dateParts[2], DECIMAL_RADIX);
        const monthDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        if (dateMonth <= 0 || dateMonth > 12) {
            return false;
        }

        // Check for leap years
        if (dateYear % 400 === 0 || (dateYear % 100 !== 0 && dateYear % 4 === 0)) {
            monthDays[1] = 29;
        }

        if (dateDay <= 0 || dateDay > monthDays[dateMonth - 1]) {
            return false;
        }
        return true;
    };

    const getDischargeDateValidationError: Validator = (value: FieldContent): ErrorId | ExtendedErrorId | undefined => {
        const invalidDischargeDate: ErrorId = 'invalidDischargeDate';
        const notWithinOneYear: ExtendedErrorId = 'noWithinOneYear';

        if (value === undefined || !isValidDateFormat(value.toString()) || !isValidDate(value.toString())) {
            return invalidDischargeDate;
        }
        const dischargeDate = new Date(value.toString());
        const dischargeYear = dischargeDate.getFullYear();
        const dischargeMonth = dischargeDate.getMonth();

        if (dischargeYear > thisYear
            || dischargeYear < lastYear
            || (dischargeYear === thisYear && dischargeMonth > thisMonth)
            || (dischargeYear === lastYear && dischargeMonth < thisMonth)) {
            return notWithinOneYear;
        }
        return null;
    };
    overrideValidator('dischargeDate', getDischargeDateValidationError);
};
